import api from 'services/api/microfwk';
import qs from 'qs';
import _ from 'lodash';

export const getUserInfo = (body, params = {}) =>
  api
    .post('/services/user/getuserinfo', null, {
      params: { ...params, HKS: null },
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) throw data;
      throw error;
    });
